import { normalizePath } from "../data/seo.js";

export function isActivePath(currentPath, itemPath) {
  return normalizePath(currentPath) === normalizePath(itemPath);
}

export function routeLabelFromPath(path) {
  const normalized = normalizePath(path);
  if (normalized === "/") return "Home";
  return normalized
    .slice(1)
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
